(function () {
  'use strict';

  /* ───────── 配置（与 v2.0 一致，零改动）───────── */
  const STORAGE_KEY = 'region_suggest_dismissed_until';     // 明确关闭（Stay / ×）：30 天
  const SESSION_KEY = 'region_suggest_dismissed_session';   // 轻关闭（遮罩 / ESC）：仅本次会话
  const DISMISS_DAYS = 30;
  const EXCLUDED_PATHS = ['/checkouts', '/cart'];
  const STORE_MAP = {
    US: { domain: 'katchme.com',   label: 'United States',  currency: 'USD', symbol: '$', shippingNote: 'US shipping' },
    GB: { domain: 'katchme.co.uk', label: 'United Kingdom', currency: 'GBP', symbol: '£', shippingNote: 'UK shipping' }
  };

  /* ───────── 样式（运行时注入；全部走主题 CSS 变量，自动贴合品牌字体/配色）───────── */
  const STYLE_ID = 'region-suggestion-modal-styles';
  const CSS = `
.region-suggestion-modal{position:fixed;inset:0;z-index:100000;display:flex;align-items:center;justify-content:center;padding:1.5rem;background:var(--overlay-bg,rgba(0,0,0,.6));opacity:0;visibility:hidden;transition:opacity var(--duration-long,.4s) var(--ease-out,ease),visibility 0s linear var(--duration-long,.4s);}
.region-suggestion-modal.is-visible{opacity:1;visibility:visible;transition:opacity var(--duration-long,.4s) var(--ease-out,ease);}
.region-suggestion-modal__dialog{position:relative;box-sizing:border-box;width:100%;max-width:36rem;padding:clamp(2.75rem,5vw,3.75rem) clamp(2rem,4vw,3rem);text-align:left;border-radius:12px;background:var(--color-background,#fff);color:var(--color-text,#222);box-shadow:var(--shadow,0 12px 44px rgba(0,0,0,.18));font-family:var(--body-font-family,inherit);line-height:var(--body-line-height,1.55);transform:translateY(16px) scale(.97);transition:transform var(--duration-long,.4s) var(--ease-out,ease);}
.region-suggestion-modal.is-visible .region-suggestion-modal__dialog{transform:none;}
.region-suggestion-modal__title{margin:0 0 .6rem;padding-right:2.25rem;font-family:var(--heading-font,inherit);font-style:var(--heading-font-style,normal);font-weight:var(--heading-weight,700);color:var(--color-heading,#222);font-size:2rem;line-height:1.22;}
.region-suggestion-modal__text{margin:0 0 1.7rem;color:rgba(var(--color-text-rgb,34,34,34),.7);font-size:1.1875rem;}
.region-suggestion-modal__regions{display:flex;flex-direction:column;gap:.85rem;margin:0 0 1.7rem;}
.region-suggestion-modal__opt{display:flex;align-items:center;gap:.9rem;width:100%;box-sizing:border-box;padding:1.55rem 1.6rem;border-radius:10px;border:1px solid transparent;font-family:inherit;text-align:left;cursor:pointer;transition:transform .16s var(--ease-out,ease),background-color .16s ease,border-color .16s ease;}
.region-suggestion-modal__opt:hover{transform:translateY(-1px);}
.region-suggestion-modal__opt--rec{background:var(--color-heading,#1d1d1f);border-color:var(--color-heading,#1d1d1f);color:#fff;}
.region-suggestion-modal__opt--rec .region-suggestion-modal__opt-sub{color:rgba(255,255,255,.6);}
.region-suggestion-modal__opt--alt{background:transparent;border-color:var(--border-color,#e5e5e5);color:var(--color-heading,#222);}
.region-suggestion-modal__opt--alt:hover{background:var(--accent-color-second,#f6f4f0);border-color:var(--color-heading,#222);}
.region-suggestion-modal__opt:focus-visible{outline:2px solid var(--color-heading,#222);outline-offset:2px;}
.region-suggestion-modal__eyebrow{display:block;font-size:.75rem;letter-spacing:.18em;text-transform:uppercase;opacity:.7;margin-bottom:.35rem;}
.region-suggestion-modal__opt-text{flex:1;min-width:0;}
.region-suggestion-modal__opt-main{display:block;font-weight:600;font-size:1.625rem;line-height:1.2;}
.region-suggestion-modal__opt-sub{display:block;margin-top:.3rem;font-size:1rem;color:rgba(var(--color-text-rgb,34,34,34),.6);}
.region-suggestion-modal__opt-cur{flex:0 0 auto;font-size:1.5rem;font-weight:600;line-height:1;}
.region-suggestion-modal__stay{display:block;margin:0 auto;background:none;border:none;padding:.7rem 1.2rem;color:var(--color-text,#222);font-family:var(--btn-font,inherit);font-size:1.1875rem;letter-spacing:.01em;text-decoration:underline;text-underline-offset:5px;text-decoration-thickness:1px;opacity:.85;cursor:pointer;transition:opacity 140ms ease;}
.region-suggestion-modal__stay:hover{opacity:1;text-decoration-thickness:2px;}
.region-suggestion-modal__stay:focus-visible{outline:2px solid var(--color-heading,#222);outline-offset:2px;}
.region-suggestion-modal__close{position:absolute;top:1.1rem;right:1.1rem;display:flex;align-items:center;justify-content:center;width:32px;height:32px;background:none;border:none;color:var(--color-heading,#222);opacity:.55;cursor:pointer;transition:opacity 120ms ease;}
.region-suggestion-modal__close:hover{opacity:1;}
.region-suggestion-modal__close:focus-visible{outline:2px solid var(--color-heading,#222);outline-offset:2px;border-radius:4px;}
@media (max-width:768px){
.region-suggestion-modal{padding:1.25rem;}
.region-suggestion-modal__dialog{padding:2.5rem 1.5rem 2rem;}
.region-suggestion-modal__title{font-size:1.625rem;}
}
@media (prefers-reduced-motion:reduce){
.region-suggestion-modal,.region-suggestion-modal__dialog{transition:none;}
}`;

  const X_ICON = '<svg width="20" height="20" viewBox="0 0 18 18" fill="none"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';

  /* ───────── 地区项（从 STORE_MAP 派生；检测到的目标 = 深色推荐卡，排第一）───────── */
  function regionsHtml(targetCode) {
    const codes = Object.keys(STORE_MAP).sort((a, b) => (a === targetCode ? -1 : b === targetCode ? 1 : 0));
    return codes.map(code => {
      const s = STORE_MAP[code];
      const rec = code === targetCode;
      return `
        <button type="button" class="region-suggestion-modal__opt region-suggestion-modal__opt--${rec ? 'rec' : 'alt'}" data-code="${code}">
          <span class="region-suggestion-modal__opt-text">
            ${rec ? '<span class="region-suggestion-modal__eyebrow">Suggested for you</span>' : ''}
            <span class="region-suggestion-modal__opt-main">${s.label}</span>
            <span class="region-suggestion-modal__opt-sub">${s.shippingNote}</span>
          </span>
          <span class="region-suggestion-modal__opt-cur" aria-hidden="true">${s.symbol}</span>
        </button>`;
    }).join('');
  }

  /* ───────── 工具（沿用 v2.0）───────── */
  function isDismissed() {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return true;   // 本次会话内已轻关闭
      const until = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
      return until > Date.now();                              // 30 天内已明确关闭
    } catch (e) { return false; }
  }

  function setDismissed() {           // 明确动作（Stay / ×）：记 30 天
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now() + DISMISS_DAYS * 86400000));
    } catch (e) {}
  }

  function setSessionDismissed() {    // 轻关闭（遮罩 / ESC）：仅本次会话，下次访问还会弹
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {}
  }

  function isExcludedPath() {
    return EXCLUDED_PATHS.some(p => location.pathname.startsWith(p));
  }

  function getCurrentDomain() {
    return location.hostname.replace(/^www\./, '');
  }

  async function detectCountry() {
    // 优先级 1：Shopify.country 指向一个跟当前店"不同"的店
    const shopifyCountry = (window.Shopify && window.Shopify.country || '').toUpperCase();
    if (shopifyCountry) {
      const picked = STORE_MAP[shopifyCountry];
      if (picked && picked.domain !== getCurrentDomain()) {
        return shopifyCountry;
      }
    }
    // 优先级 2：fallback 到 IP 检测
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const res = await fetch(root + 'browsing_context_suggestions.json?country%5Benabled%5D=true', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('http_' + res.status);
    const data = await res.json();
    return data && data.detected_values && data.detected_values.country
      ? data.detected_values.country.handle
      : null;
  }

  /* ───────── 弹窗：注入样式 + 构建 DOM + 开关 ───────── */
  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    document.head.appendChild(style);
  }

  let lastFocused = null;

  // 注意：插值全部取自写死的 STORE_MAP（受信常量），非用户输入，innerHTML 无 XSS 风险
  function open(targetCode) {
    injectStyles();
    const target = STORE_MAP[targetCode];

    const overlay = document.createElement('div');
    overlay.id = 'RegionSuggestionModal';
    overlay.className = 'region-suggestion-modal';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-labelledby', 'rsm-title');
    overlay.innerHTML = `
      <div class="region-suggestion-modal__dialog">
        <button type="button" class="region-suggestion-modal__close" aria-label="Dismiss">${X_ICON}</button>
        <h2 id="rsm-title" class="region-suggestion-modal__title">Looks like you're shopping from ${target.label}.</h2>
        <p class="region-suggestion-modal__text">Choose where you'd like to shop.</p>
        <div class="region-suggestion-modal__regions">${regionsHtml(targetCode)}</div>
        <button type="button" class="region-suggestion-modal__stay" data-action="stay">Stay here</button>
      </div>`;
    document.body.appendChild(overlay);

    const prevOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    lastFocused = document.activeElement;

    function close(persist) {
      if (persist) setDismissed(); else setSessionDismissed();
      document.removeEventListener('keydown', onKeydown);
      document.documentElement.style.overflow = prevOverflow;
      overlay.classList.remove('is-visible');
      const remove = () => { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); };
      overlay.addEventListener('transitionend', remove, { once: true });
      setTimeout(remove, 600); // 兜底：prefers-reduced-motion 下无 transitionend
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') { close(false); return; }   // ESC = 轻关闭（仅本次会话）
      if (e.key !== 'Tab') return;
      const items = [...overlay.querySelectorAll('button')];
      if (!items.length) return;
      const first = items[0];
      const last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    // 点地区卡：已在该店 = 留在本页 + 记 30 天（不跳首页）；另一店 = 跳转
    [...overlay.querySelectorAll('[data-code]')].forEach(opt => {
      opt.addEventListener('click', () => {
        const store = STORE_MAP[opt.getAttribute('data-code')];
        if (!store) return;
        if (store.domain === getCurrentDomain()) { close(true); return; }
        location.href = 'https://' + store.domain + '/';
      });
    });
    // Stay / × = 记 30 天
    [...overlay.querySelectorAll('[data-action="stay"], .region-suggestion-modal__close')]
      .forEach(el => el.addEventListener('click', () => close(true)));
    // 点遮罩 = 轻关闭
    overlay.addEventListener('click', (e) => { if (e.target === overlay) close(false); });
    document.addEventListener('keydown', onKeydown);

    requestAnimationFrame(() => {
      overlay.classList.add('is-visible');
      const firstOpt = overlay.querySelector('[data-code]');
      if (firstOpt) firstOpt.focus();
    });
  }

  async function init() {
    if (isExcludedPath()) return;
    if (isDismissed()) return;
    try {
      const detected = await detectCountry();
      if (!detected) return;
      const target = STORE_MAP[detected];
      if (!target) return;
      if (target.domain === getCurrentDomain()) return;
      open(detected);
    } catch (e) {
      if (window.console && console.debug) console.debug('[RegionModal]', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
